import mutations from './mutations';
import actions from './actions/index';
import { toBoolean } from '../../modules/dataHelper';

export default {
  state: {
    mentees: [],
    menteeRequests: [],
    goals: [],
  },
  getters: {
    newMentees(state) {
      return state.menteeRequests.filter(m => !toBoolean(m.status));
    },
    myMentees(state) {
      return state.mentees;
    },
    getMentee: state => id => state.mentees.find(m => m.menteeid === id),
    getMentorGoal: state => id => state.goals.find(g => g === id),
  },
  mutations,
  actions,
};
